var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCasingListIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77856 14.4296L2.41626 17.6289",
    stroke: "#C1E2E6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2743 11.1439C25.0191 9.70382 24.5876 7.75499 23.0781 7.00026C22.2812 6.62526 21.2968 6.43776 20.5 6.85963C18.25 9.62526 15.9062 12.2971 13.6562 15.0628C13.1406 15.4846 12.8593 16.094 12.3965 16.5303",
    stroke: "#C1E2E6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8252 22.2256L23.2153 12.9649",
    stroke: "#C1E2E6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1293 15.6934L20.9946 6.22367L20.9947 6.22372C21.3759 5.71499 21.6017 5.08306 21.6017 4.39845C21.6017 2.71578 20.2376 1.35167 18.555 1.35167C17.7533 1.35167 17.024 1.66128 16.48 2.16744L16.4801 2.16758L7.04883 9.90959",
    stroke: "#C1E2E6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78863 8.89886C7.4588 8.89886 5.57007 10.7875 5.57007 13.1174C5.57007 15.4473 7.4588 17.3359 9.78863 17.3359C12.1185 17.3359 14.0071 15.4473 14.0071 13.1174C14.0071 10.7875 12.1185 8.89886 9.78863 8.89886Z",
    stroke: "#C1E2E6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95921 11.9896C6.81957 12.3387 6.74194 12.719 6.74194 13.1174C6.74194 14.7973 8.10863 16.1641 9.78858 16.1641C11.4685 16.1641 12.8352 14.7973 12.8352 13.1174C12.8352 11.4374 11.4685 10.0707 9.78858 10.0707C9.18432 10.0707 8.62107 10.2483 8.14688 10.5529",
    stroke: "#C1E2E6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57013 24.6484C3.2403 24.6484 1.35156 22.7597 1.35156 20.4299C1.35156 18.1 3.2403 16.2114 5.57013 16.2114C7.89995 16.2114 9.78869 18.1 9.78869 20.4299C9.78869 22.7597 7.89995 24.6484 5.57013 24.6484Z",
    stroke: "#C1E2E6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57008 23.4766C3.89017 23.4766 2.52344 22.1098 2.52344 20.4299C2.52344 18.75 3.89017 17.3832 5.57008 17.3832C7.25003 17.3832 8.61677 18.75 8.61677 20.4299C8.61677 22.1098 7.25003 23.4766 5.57008 23.4766Z",
    stroke: "#C1E2E6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0071 24.6484C11.6773 24.6484 9.78857 22.7597 9.78857 20.4299C9.78857 18.1 11.6773 16.2114 14.0071 16.2114C16.3369 16.2114 18.2257 18.1 18.2257 20.4299C18.2257 22.7597 16.3369 24.6484 14.0071 24.6484Z",
    stroke: "#C1E2E6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0071 23.4766C12.3272 23.4766 10.9604 22.1098 10.9604 20.4299C10.9604 18.75 12.3272 17.3832 14.0071 17.3832C15.687 17.3832 17.0538 18.75 17.0538 20.4299C17.0538 22.1098 15.687 23.4766 14.0071 23.4766Z",
    stroke: "#C1E2E6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCasingListIcon);
export default __webpack_public_path__ + "static/media/casingListIcon.417a492bf635f11d4c320f70ca88a6d6.svg";
export { ForwardRef as ReactComponent };